import React, { useState } from 'react';
import Modal from './Modal';

export default function PaymentModal({ isOpen, onClose, onSubmit, invoiceTotal, formatCurrency }) {
  const [amount, setAmount] = useState(invoiceTotal);
  const [paymentMethod, setPaymentMethod] = useState('bank_transfer');
  
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({
      amount: parseFloat(amount),
      method: paymentMethod
    });
    onClose();
  };
  
  const paymentMethods = [
    { value: 'bank_transfer', label: 'Bank Transfer', icon: '🏦' },
    { value: 'cash', label: 'Cash', icon: '💵' },
    { value: 'credit_card', label: 'Credit Card', icon: '💳' },
    { value: 'check', label: 'Check', icon: '📝' }
  ];
  
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Process Payment">
      <form onSubmit={handleSubmit}>
        <div className="modal-form-group">
          <label className="modal-label">Payment Amount</label>
          <input
            type="number"
            className="modal-input"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            min="0.01"
            step="0.01"
            required
          />
          <div className="text-sm text-gray-500 mt-1">
            Invoice Total: {formatCurrency(invoiceTotal)}
          </div>
        </div>
        
        <div className="modal-form-group">
          <label className="modal-label">Payment Method</label>
          <div className="payment-method-options">
            {paymentMethods.map((method) => (
              <div
                key={method.value}
                className={`payment-method-option ${paymentMethod === method.value ? 'selected' : ''}`}
                onClick={() => setPaymentMethod(method.value)}
              >
                <span className="payment-method-option-icon">{method.icon}</span>
                <span>{method.label}</span>
              </div>
            ))}
          </div>
        </div>
        
        <div className="modal-footer">
          <button
            type="button"
            className="modal-btn modal-btn-secondary"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="modal-btn modal-btn-primary"
          >
            Process Payment
          </button>
        </div>
      </form>
    </Modal>
  );
}